"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListChooserTitle = exports.MultiListChooserContent = void 0;
const core_api_1 = require("@ikegps/core-api");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const multi_list_search_1 = require("../multi.list.search/multi.list.search");
const multi_list_chooser_style_1 = require("./multi.list.chooser.style");
const nested_list_chooser_state_1 = require("./nested.list.chooser.state");
const select_list_chooser_state_1 = require("./select.list.chooser.state");
(0, theme_1.addStyles)(multi_list_chooser_style_1.Style);
function focusNode(e) {
    setTimeout(() => e.dom.focus(), 10);
}
exports.MultiListChooserContent = {
    view(state) {
        const groupNodes = [];
        const filteredItemNodes = [];
        const groups = state.groups;
        if (state.hasError()) {
            return (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.container }, (0, i18n_1.Translate)(state.error));
        }
        if (groups == null) {
            return (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.container }, spinner_1.Spinner.view());
        }
        if (services_1.Services.MultiListSearch.inputfilterState.hasFilter()) {
            const flattenedEntryList = state.getAllOptions();
            const optionsValueKeyMap = new Map(flattenedEntryList.map((x) => [x.map((y) => y.value).join(' > '), x.map((z) => z.key)]));
            const filteredEntryList = flattenedEntryList
                .map((x) => x.map((y) => y.value).join(' > '))
                .filter((z) => z.toLowerCase().includes(services_1.Services.MultiListSearch.inputfilterState.filter.toLowerCase()));
            for (let i = 0; i < filteredEntryList.length; i++) {
                const filteredEntry = filteredEntryList[i];
                const id = `filtered-list-item-${i}`;
                const inputId = `${id}-input`;
                const isSelected = state.value && state.value.join(' > ') === filteredEntry;
                const shouldFocus = i === 0 && isSelected;
                const filteredItemNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selection, id }, [
                    (0, mithril_1.m)('input', {
                        type: 'radio',
                        id: inputId,
                        checked: isSelected ? 'checked' : null,
                        onchange: () => state.setValue(optionsValueKeyMap.get(filteredEntry)),
                        oncreate: () => (shouldFocus ? focusNode : null),
                    }),
                    (0, mithril_1.m)('label', { for: inputId }, filteredEntry),
                ]);
                filteredItemNodes.push(filteredItemNode);
            }
            const groupNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.container }, [
                (0, mithril_1.m)('label', { className: multi_list_chooser_style_1.CSS.group.title, for: name }, (0, i18n_1.Translate)(i18n_1.T.SEARCH_RES)),
                (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selectionWrap }, filteredItemNodes),
            ]);
            groupNodes.push(groupNode);
        }
        else {
            let isColorField = false;
            if (
            // We have the correct token
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) &&
                // And the field is one of the two list types which can have colors
                (state instanceof select_list_chooser_state_1.SelectListChooserState || state instanceof nested_list_chooser_state_1.NestedListChooserState) &&
                // And this instance is the one that is marked as the color field
                state.field.collection.schema.metadata.mapColorFieldId === state.field.schema.id) {
                isColorField = true;
            }
            for (let i = 0; i < groups.length; i++) {
                const group = groups[i];
                const name = `multi-list-group-${i}`;
                const itemNodes = [];
                for (let j = 0; j < group.items.length; j++) {
                    const item = group.items[j];
                    const id = `${name}-${j}`;
                    const inputId = `${id}-input`;
                    const isSelected = group.selected === item.key;
                    const shouldFocus = i === 0 && isSelected;
                    const hasColor = item.color != null;
                    const stateValue = [...groups.slice(0, i).map((g) => g.selected), item.key];
                    const children = [
                        (0, mithril_1.m)('input', {
                            type: 'radio',
                            id: inputId,
                            name,
                            checked: isSelected ? 'checked' : null,
                            onchange: () => state.setValue(stateValue),
                            oncreate: shouldFocus ? focusNode : null,
                        }),
                        (0, mithril_1.m)('label', { for: inputId }, item.value),
                    ];
                    if (isColorField && hasColor) {
                        children.push((0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.colorIndicator, style: { 'background-color': item.color } }));
                    }
                    itemNodes.push((0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selection, id }, children));
                }
                if (itemNodes.length > 0) {
                    const groupNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.container }, [
                        (0, mithril_1.m)('label', { className: multi_list_chooser_style_1.CSS.group.title, for: name }, group.title),
                        (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selectionWrap }, itemNodes),
                    ]);
                    groupNodes.push(groupNode);
                }
            }
        }
        const chooserNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.chooserContainer }, groupNodes);
        const filterNode = new multi_list_search_1.MultiListSearch().nodes;
        const dialogNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.container }, [filterNode, chooserNode]);
        return dialogNode;
    },
};
exports.MultiListChooserTitle = {
    view(ctrl) {
        return (0, i18n_1.Translate)(i18n_1.T.SELECT, ctrl.label);
    },
};
//# sourceMappingURL=multi.list.chooser.js.map